import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrl, baseUrl } from "../../../utils/apis";
import { AdminStaffProfile, LawyerProfile, ProfileApiResponse } from "./types";

// ===========================
// TYPES
// ===========================



// ===========================
// API SETUP
// ===========================
export const profileApi = createApi({
    reducerPath: "profileApi",
    baseQuery: fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            const token = sessionStorage.getItem("token");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    tagTypes: ["Profile"],

    endpoints: (builder) => ({
        // GET PROFILE
        getProfile: builder.query<ProfileApiResponse, void>({
            query: () => ({
                url: apiUrl.profileUrl,
                method: "GET",
            }),
            providesTags: ["Profile"],
        }),

        // UPDATE PROFILE
        updateProfile: builder.mutation<any, FormData>({
            query: (body) => ({
                url: apiUrl.account_Update,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["Profile"],
        }),
        updateLawyerProfile: builder.mutation({
            query: (bodyData: LawyerProfile) => ({
                url: apiUrl.lawyer_Profile,
                method: "POST",
                body: bodyData,
            }),
            invalidatesTags: ["Profile"],
        }),
        updateStaffProfile: builder.mutation({
            query: (bodyData: AdminStaffProfile) => ({
                url: apiUrl.AdminStaff,
                method: "POST",
                body: bodyData,
            }),
            invalidatesTags: ["Profile"],
        }),

    }),
});

export const { useGetProfileQuery, useUpdateProfileMutation, useUpdateLawyerProfileMutation,useUpdateStaffProfileMutation } = profileApi;
